import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=2f14b06c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=2f14b06c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14b06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f14b06c')) {
      api.createRecord('2f14b06c', component.options)
    } else {
      api.reload('2f14b06c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=2f14b06c&scoped=true&", function () {
      api.rerender('2f14b06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RmR2VfPmcnHT/JS/comp/Voucher.vue"
export default component.exports